import {ReactNode} from 'react';

export type Capture = "user" | "environment";

export type Color =
  | "primary"
  | "secondary"
  | "success"
  | "warning"
  | "danger"
  | "info"
  | "light"
  | "dark"
  | "blue"
  | "azure"
  | "indigo"
  | "purple"
  | "pink"
  | "red"
  | "orange"
  | "yellow"
  | "lime"
  | "green"
  | "teal"
  | "cyan";

export type InputType =
  | "checkbox"
  | "color"
  | "date"
  | "email"
  | "file"
  | "hidden"
  | "image"
  | "month"
  | "number"
  | "password"
  | "radio"
  | "range"
  | "reset"
  | "search"
  | "submit"
  | "tel"
  | "text"
  | "time"
  | "url"
  | "week";

export type Size = "xs" | "sm" | "md" | "lg" | "xl";
export type Theme = "light" | "dark";

export type User = {
  businessUnit?: SelectOption;
  displayName: string;
  email: string;
  firstName: string;
  id: string;
  lastName: string;
  middleName: string;
  phoneNumber: string;
  roles: UserRole[];
  userName: string;
};

export interface SelectOption {
  id: number | string;
  name: string;
}

export interface UserRole {
  id: number;
  user: User;
  role: Role;
}

export interface Role {
  id: string;
  name: string;
}

export interface TagInfo {
  id: number;
  color: string;
  text: string;
}

export type JwtResponse = {
    token: string;
    refreshToken: string;
    success: boolean;
    errors: string[];
}
export type AccordionData = {
  title: string;
  content: ReactNode;
}
export class RefreshToken {
    public Token: string;
    public refreshToken?: string

    public constructor(token: string, refreshToken?: string) {
        this.Token = token;
        this.refreshToken = refreshToken;
    }
};

export class AccessToken {
    public AppGuid: string;
    public AppName: string;
    public UserEmail: string;

    public constructor(appGuid: string, appName: string, userEmail: string) {
        this.AppGuid = appGuid;
        this.AppName = appName;
        this.UserEmail = userEmail;
    }
};

export class UserSecurity {
    public email: string;
    public userClaimsObjectId: string;    

    public constructor(email: string, userClaimsObjectId: string) {
        this.email = email;
        this.userClaimsObjectId = userClaimsObjectId;
    }
}


